import { BaseConnection } from "./connection";

export enum SystemPersonConnectionTypes {
  SPOUSE = "spouse",
  RELATIVE = "relative",
  TEACHER_OF = "teacher_of",
  CHILDREN = "children",
}

export type SystemPersonImpliesConnectionTypes =
  | SystemPersonConnectionTypes.TEACHER_OF
  | SystemPersonConnectionTypes.CHILDREN;

export const SYSTEM_PERSON_IMPLIES_CONNECTION_TYPES: SystemPersonImpliesConnectionTypes[] =
  [
    SystemPersonConnectionTypes.TEACHER_OF,
    SystemPersonConnectionTypes.CHILDREN,
  ];

export const PERSON_CONNECTION_TYPE_LABELS: Record<
  SystemPersonConnectionTypes,
  string
> = {
  [SystemPersonConnectionTypes.SPOUSE]: "Spouse",
  [SystemPersonConnectionTypes.RELATIVE]: "Relative",
  [SystemPersonConnectionTypes.TEACHER_OF]: "Teacher of",
  [SystemPersonConnectionTypes.CHILDREN]: "Children",
};

export const PERSON_IMPLIES_CONNECTION_TYPE_LABELS: Record<
  SystemPersonImpliesConnectionTypes,
  string
> = {
  [SystemPersonConnectionTypes.TEACHER_OF]: "Disciple",
  [SystemPersonConnectionTypes.CHILDREN]: "Child Of",
};

export interface PersonConnection extends BaseConnection {
  system_person_connection_type: SystemPersonConnectionTypes | null;
}

export interface PersonConnectionFilters extends BaseConnection {
  system_person_connection_type:
    | SystemPersonConnectionTypes[]
    | SystemPersonConnectionTypes
    | null;
}
